<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="p-g-12">
    <p-toast position="top-right"></p-toast>
    <p-toolbar>
        <div class="p-toolbar-group-left p-toolbar-tecfolk-fix">
            <button routerLink="/requests-management" pButton type="button" [label]='setLabel("goBackBtnLabel")'
                icon="pi pi-arrow-left"></button>&nbsp;
            <button (click)="printRequestDetail()"
                class="p-button p-widget p-state-default p-corner-all p-button-text-only printButton">
                <i class="fa fa-print printIcon" aria-hidden="true"></i> {{setLabel("printBtnLabel")}}
            </button>
        </div>
    </p-toolbar>
</div>
<div class="p-g-12 requestDetail">
    <form class="form" #requestorForm="ngForm" (ngSubmit)="update(requestorForm)" style="display: flex; flex-direction: column;">
        <div class="p-g-12">
            <div class="p-g-12 p-md-10">
                <h3 class="Main-heading first">{{setLabel("memberDetailsLabel")}}</h3>
            </div>
            <div class="imgContainer">
                <div class="imgCard-detail">
                    <span class="imgContainer-span">{{setLabel("profileImageLabel")}}</span>
                    <img class="img" [src]="
                            requestor.profile == null
                                ? 'assets/layout/images/avatarBoyImage.png'
                                : config.Server + config.memberImagePath + requestor.profile"
                        onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" />
                </div>
                <!-- <div *ngIf="requestor.registrationDetail.covidImageUrl" class="imgCard-detail">
                    <span class="imgContainer-span">{{setLabel("cOVIDImageLabel")}}</span>
                    <img class="img" [src]="
                            requestor.registrationDetail.covidImageUrl == null
                                ? 'assets/layout/images/covid.png'
                                : config.Server + config.covidImagePath +
                                  requestor.registrationDetail.covidImageUrl"
                        onerror="this.src = 'assets/layout/images/covid.png'" />
                </div> -->
                <div class="imgCard-detail">
                    <span class="imgContainer-span">{{setLabel("cNICImageLabel")}}</span>
                    <img class="img" [src]="
                            requestor.registrationDetail.CNICImageUrl == null
                                ? 'assets/layout/images/CNIC.png'
                                : config.Server + config.cnicImagePath +
                                  requestor.registrationDetail.CNICImageUrl "
                        onerror="this.src = 'assets/layout/images/CNIC.png'" />
                </div>
            </div>
        </div>
        <div class="member-request-form" style="display: flex;">

        <div class="p-g-12 p-md-6">
            <div class="p-g-12">
                <h3 class="first">{{setLabel("requestIDLabel")}}</h3>
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-hashtag" aria-hidden="true"></i></span>
                    <input class="input" autocomplete="off" #requestId readonly name="requestId"
                        [(ngModel)]="requestor.requestId" />
                </div>
            </div>
            <div class="p-g-12">
                <h3 class="first">{{setLabel("nameLabel")}} <span class="asterisk">*</span></h3>
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                    <input class="input" autocomplete="off" required #memberName="ngModel" pattern="[A-Za-z ]+"
                        [ngClass]="
                            memberName.invalid &&
                            (memberName.dirty || memberName.touched)
                                ? 'errorInput'
                                : ''
                        " type="text" pInputTextplaceholder="Name*" name="memberName" [(ngModel)]="requestor.name" />
                </div>
                <div *ngIf="
                        memberName.invalid &&
                        (memberName.dirty || memberName.touched)
                    ">
                    <div *ngIf="memberName.errors.required" class="errorShow">
                        {{setLabel("nameRequiredErrorLabel")}}
                    </div>
                    <div *ngIf="memberName.errors.pattern" class="errorShow">
                        {{setLabel("charactersAllowedErrorLabel")}}
                    </div>
                </div>
            </div>
            <div class="p-g-12">
                <h3 class="first">
                    {{setLabel("mobileLabel")}} <span class="asterisk">*</span>
                </h3>
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-phone" aria-hidden="true"></i></span>
                    <app-phone-input
                        [placeholder]='setLabel("mobile*PlaceholderLabel")'
                        [(phoneNumber)]="requestor.contactDetail.contact"
                        (validNumber)="formattedNumber = $event"
                        (formattedForSaving)="requestor.contactDetail.contact= $event"
                        style="width: 60%;">
                    </app-phone-input>
                </div>
              </div>
            <div class="p-g-12">
                <h3 class="first">{{setLabel("emailLabel")}} </h3>
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-envelope" aria-hidden="true"></i></span>
                    <input class="input" type="email" autocomplete="off"
                        pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" pInputText [placeholder]='setLabel("email*PlaceholderLabel")'
                        name="email" #email="ngModel" [(ngModel)]="requestor.email" [ngClass]="
                            email.invalid && (email.dirty || email.touched)
                                ? 'errorInput'
                                : ''
                        " />
                </div>
                <div *ngIf="email.invalid && (email.dirty || email.touched)">
                    <div *ngIf="email.errors.required" class="errorShow">
                        {{setLabel("emailRequiredErrorLabel")}}
                    </div>
                    <div *ngIf="email.errors.pattern" class="errorShow">
                        {{setLabel("emailCorrectlyErrorLabel")}}
                    </div>
                </div>
            </div>
            <div class="p-g-12">
                <h3 class="first">{{setLabel("requestTypeLabel")}}</h3>
                <div class="p-inputgroup align-items-center">
                    <span class="p-inputgroup-addon"><i class="fa fa-list" aria-hidden="true"></i></span>
                    {{ requestor.requestType }}
                </div>
                <div *ngIf="existIn == 'customer'" class="existing-member-container">
                    <p>{{setLabel("alreadyRegisteredErrorLabel")}}</p>
                    <p>{{setLabel("clickViewMemberDetailsBtnLabel")}}</p>
                    <button class="p-button p-button-success p-button-rounded" (click)="redirectToMember()">
                        <i class="fa fa-arrow-circle-right"></i> {{setLabel("viewMemberDetailsLabel")}}
                    </button>
                </div>

                <div *ngIf="existIn === 'request'">
                    <p>{{setLabel("alreadyExistsOldRequestIDsLabel")}}</p>
                    <ul>
                        <li class="clickable" *ngFor="let id of alreadyExistID" (click)="redirectToRequest(id._id)">
                            {{ id.requestId }}
                        </li>
                    </ul>
                </div>

            </div>
        </div>
        <div class="p-g-12 p-md-6">
            <div class="p-g-12">
                <h3 class="first"> {{setLabel("cNICLabel")}}</h3>
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-id-card" aria-hidden="true"></i></span>
                    <input
                        type="text"
                        autocomplete="off"
                        pInputText
                        #CNIC="ngModel"
                        minlength="8"
                        maxlength="18"
                        pattern="[A-Za-z0-9]+"
                        [placeholder]='setLabel("cNICPlaceholderLabel")'
                        name="CNIC"
                        [(ngModel)]="requestor.registrationDetail.CNIC"
                         />
                </div>
                <div *ngIf="CNIC.invalid && (CNIC.dirty || CNIC.touched)"  class="errorShow">
                    <small *ngIf="CNIC.errors?.minlength">CNIC/Passport number must be at least 8 digits long.</small>
                </div>
            </div>
            <div class="p-g-12">
                <h3 class="first">{{setLabel("addressLabel")}}</h3>
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-location-arrow" aria-hidden="true"></i></span>
                    <input class="input" type="text" pInputText [placeholder]='setLabel("streetPlaceholderLabel")' name="street" autocomplete="off"
                        [(ngModel)]="requestor.contactDetail.address.street" />
                </div>
            </div>
            <div class="p-g-12">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                    <input class="input" type="text" pInputText [placeholder]='setLabel("cityPlaceholderLabel")' name="city" autocomplete="off"
                        [(ngModel)]="requestor.contactDetail.address.city" />
                </div>
            </div>
            <div class="p-g-12">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                    <input class="input" type="text" pInputText [placeholder]='setLabel("countryPlaceholderLabel")' name="country" autocomplete="off"
                        [(ngModel)]="requestor.contactDetail.address.country" />
                </div>
            </div>
            <div class="p-g-12">
                <div class="p-g">
                    <h3 class="first">{{setLabel("genderLabel")}}</h3>
                    <div class="displayFlextonDirRTL gender-option p-g-12">
                        <div class="p-g-6">
                            <p-radioButton name="gender" value="M" [label]='setLabel("maleLabel")' [(ngModel)]="requestor.gender"
                                inputId="opt1">
                            </p-radioButton>
                        </div>
                        <div class="p-g-6">
                            <p-radioButton name="gender" value="F" [label]='setLabel("femaleLabel")' [(ngModel)]="requestor.gender"
                                inputId="opt2">
                            </p-radioButton>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-g-12">
                <h3 class="first">{{setLabel("requestStatusLabel")}}</h3>
                <div class="p-inputgroup align-items-center">
                    <span class="p-inputgroup-addon"><i class="fa fa-question-circle" aria-hidden="true"></i></span>
                    {{ requestor.requestStatus }}
                </div>
            </div>
            <div class="btn-main">
                <button pButton type="button"
                    class="p-button-primary submitButton p-widget p-state-default p-corner-all rejectButton"
                    (click)="rejectRequest()" *ngIf="requestor?.requestStatus === RequestStatus.Pending">
                    <span class="p-button-text p-c">
                        <i class="fa fa-times" aria-hidden="true"></i>
                        &nbsp;{{setLabel("rejectLabel")}}
                    </span>
                </button>
                &nbsp;
                <button class="p-button p-widget p-state-default p-corner-all p-button-text-only printButton">
                    <i class="fa fa-print updateIcon" type="submit" aria-hidden="true"></i>
                    {{setLabel("updateLabel")}}
                </button>
                &nbsp;
                <button pButton type="button"
                    class="p-button-success submitButton p-widget p-state-default p-corner-all approvalButton"
                    (click)="proceedForApproval(requestorForm)"
                    *ngIf="requestor?.requestStatus === RequestStatus.Pending" [disabled]="existIn === 'customer'">
                    <!-- [disabled]="!requestorForm.valid" -->
                    <span class="p-button-text p-c">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        &nbsp;{{setLabel("proceedApprovalBtnLabel")}}
                    </span>
                </button>
            </div>
        </div>
    </div>
    </form>
</div>

<!-- ////////// For Print Registration Request Detail ////////// -->

<div id="requestDetailsForPrint" #requestDetailsForPrint style="display: none">
    <div class="invoice-box">
        <h1 style="text-align: center">{{setLabel("registrationRequestDetails")}}</h1>
        <table>
            <tbody>
                <td style="vertical-align: middle; padding: 0px">
                    <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        onerror="this.src=(company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        alt="Company Logo" style="width: 80%" />
                </td>
                <td>
                    <div style="width: 150px">{{ branch.name }}</div>
                    <div style="width: 150px">{{ branch.address }}</div>
                    <div>{{setLabel("phoneNo:Label")}} {{ branch.phone }}</div>
                    <div>{{setLabel("created:Label")}} {{ date | date : "dd/MM/yyyy" }}</div>
                </td>
            </tbody>
        </table>
        <br />
        <br />
        <div style="display: flex; justify-content: space-between">
            <div class="car-detail" style="
                    margin-bottom: 5rem;
                    flex-direction: column;
                    width: 200px;
                    height: 200px;
                ">
                <span style="
                        padding-bottom: 10px;
                        font-weight: 600;
                        display: flex;
                        justify-content: center;
                    ">{{setLabel("profileImageLabel")}}</span>

                <img width="100%" height="100%" [src]="
                        requestor.profile == null
                            ? 'assets/layout/images/avatarBoyImage.png'
                            : config.Server + config.memberImagePath + requestor.profile
                    " />
            </div>
            <!-- <div class="car-detail" style="width: 250px; height: 200px">
                <span style="
                        padding-bottom: 10px;
                        font-weight: 600;
                        display: flex;
                        justify-content: center;
                    ">{{setLabel("cOVIDImageLabel")}}</span>
                <img width="100%" height="100%" [src]="
                        requestor.profile == null
                            ? 'assets/layout/images/avatarBoyImage.png'
                            : config.Server + config.covidImagePath +
                              requestor.registrationDetail.covidImageUrl
                    " />
            </div> -->
            <div class="car-detail" style="width: 250px; height: 200px">
                <span style="
                        padding-bottom: 10px;
                        font-weight: 600;
                        display: flex;
                        justify-content: center;
                    ">{{setLabel("cNICImageLabel")}}</span>
                <img width="100%" height="100%" [src]="
                        requestor.profile == null
                            ? 'assets/layout/images/avatarBoyImage.png'
                            : config.Server + config.cnicImagePath +
                              requestor.registrationDetail.CNICImageUrl
                    " />
            </div>
        </div>
        <table style="display: flex; justify-content: center">
            <tbody>
                <tr class="information">
                    <td style="
                            padding-bottom: 10px;
                            text-align-last: start !important;
                            font-weight: 600;
                        ">
                        {{setLabel("requestID:Label")}}
                    </td>
                    <td class="rqName" style="padding-bottom: 10px">
                        {{ requestor.requestId }}
                    </td>
                    <td></td>
                    <td style="
                            padding-bottom: 10px;
                            font-weight: 600;
                            padding-left: 20px;
                        ">
                        {{setLabel("cNIC:Label")}}
                    </td>
                    <td style="padding-bottom: 10px">
                        {{ requestor.registrationDetail.CNIC }}
                    </td>
                    <td></td>
                </tr>
                <tr class="information">
                    <td style="
                            padding-bottom: 10px;
                            text-align-last: start !important;
                            font-weight: 600;
                        ">
                        {{setLabel("name:Label")}}
                    </td>
                    <td class="rqName" style="padding-bottom: 10px">
                        {{ requestor.name }}
                    </td>
                    <td></td>
                    <td style="
                            padding-bottom: 10px;
                            font-weight: 600;
                            padding-left: 20px;
                        ">
                        {{setLabel("gender:Label")}}
                    </td>
                    <td style="padding-bottom: 10px">{{ requestor.gender }}</td>
                    <td></td>
                </tr>
                <tr class="information">
                    <td style="padding-bottom: 10px; font-weight: 600">
                        {{setLabel("email:Label")}}
                    </td>
                    <td style="padding-bottom: 10px">{{ requestor.email }}</td>
                    <td></td>
                    <td style="
                            padding-bottom: 10px;
                            padding-left: 20px;
                            font-weight: 600;
                        ">
                       {{setLabel("mobile:Label")}}
                    </td>
                    <td style="padding-bottom: 10px">
                        {{ requestor.contactDetail.contact }}
                    </td>
                </tr>
                <tr class="information">
                    <td style="padding-bottom: 10px; font-weight: 600">
                        {{setLabel("address:Label")}}
                    </td>
                    <td style="padding-bottom: 10px; text-align: left">
                        {{ requestor.contactDetail.address.street }},{{
                        requestor.contactDetail.address.city
                        }}
                    </td>
                    <td></td>
                    <td style="
                            padding-bottom: 10px;
                            padding-left: 20px;
                            font-weight: 600;
                        ">
                        {{setLabel("requestType:Label")}}
                    </td>
                    <td style="padding-bottom: 10px; text-align: left">
                        {{ requestor.requestType }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="branch?.termsAndConditions"
            style="margin-top: 20px; border: 1px solid #ddd; padding: 15px; border-radius: 5px;">
            <div style="font-weight: bold; margin-bottom: 10px; text-align: center;">
                {{ setLabel("termsAndCondition:Label") }}
            </div>        
            <div [innerHTML]="branch?.termsAndConditions" style="margin-bottom: 15px;"></div>        
            <div style="display: flex; align-items: center;">
                <input type="checkbox" checked style="width: 20px; height: 20px; margin-right: 10px;" />
                <label style="font-weight: bold; margin: 0;">Agreed to the Terms and Conditions</label>
            </div>
        </div>
        <br />
        <br />
        <table style="display: flex; justify-content: center">
            <tbody>
                <tr>
                    <td>
                        <div style="text-align: center" class="logoDiv">
                            {{setLabel("poweredByLabel")}}&nbsp;
                            <a href="http://tecfolk.com/" target="_blank">
                                <img style="width: 66px"
                                    src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt="" />
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>